import React, { useEffect, useState } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { msalInstance } from '../auth/msalInstance';
import Loader from '../components/Loader/Loader';

const RootRedirect = () => {
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [redirectComplete, setRedirectComplete] = useState(false);

    useEffect(() => {
        msalInstance.handleRedirectPromise().then(() => {
            setRedirectComplete(true);
        });
    }, []);

    useEffect(() => {
        if (!redirectComplete) return;

        if (isAuthenticated) {
            navigate('/CMIHome', { replace: true });
        } else {
            instance.loginRedirect();
        }
    }, [redirectComplete, isAuthenticated, instance, navigate]);

    return <div><Loader/></div>;
};

export default RootRedirect;